import type { CatalogProduct, Plan } from '@aibees/shared/definition';

/**
 * The key correlating a product across responses — `family` for grouped plans,
 * falling back to `slug`.
 *
 * Use this to match a product against data from a *different* endpoint (or a
 * different `return=` shape of the same one): product ids are not guaranteed to
 * be stable across those shapes, whereas family/slug is the grouping the
 * backend itself keys on. For reading a column out of a feature's `cells`, use
 * `matchColumnKey` instead.
 */
export function productFamilyKey(product: CatalogProduct): string | undefined {
  return product.metadata.family ?? product.metadata.slug;
}

/** `productFamilyKey` for the product a plan belongs to. */
export function planFamilyKey(plan: Plan): string | undefined {
  return plan.product?.metadata?.family ?? plan.product?.metadata?.slug;
}
